import React from 'react';
import PropTypes from 'prop-types';
import { /* Card, */ CloseButton, Modal } from 'react-bootstrap';
/* import IconButton from 'components/common/IconButton'; */
/* import { currency } from 'helpers/utils'; */

const ModalEfectyQr = ({ show, navigat /* , dataPay */ }) => {
 return (
  <Modal show={show} onHide={navigat} className="mt-4">
   <Modal.Header className="bg-shape modal-shape-header px-4 position-relative">
    <div className="position-relative z-index-1 light">
     <h4 className="mb-0 text-white" id="authentication-modal-label">
      Register
     </h4>
     <p className="fs--1 mb-0 text-white">Please create your free Falcon account</p>
    </div>
    <CloseButton variant="white" className="position-absolute end-0 me-2 mt-2 top-0" onClick={navigat} />
   </Modal.Header>
   <Modal.Body className="p-4"></Modal.Body>
  </Modal>
 );
};

ModalEfectyQr.propTypes = {
 show: PropTypes.bool.isRequired,
 dataPay: PropTypes.object.isRequired,
 navigat: PropTypes.func
};

export default ModalEfectyQr;
